"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newApi = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _url = require("../util/url.js");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse,
      config = _ref.config;
  var translationNamespace = config.translationNamespace;
  return {
    setLocale: function () {
      var _setLocale = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
        var locale;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                locale = _ref2.locale;
                _context.next = 3;
                return amsResponse.getRawBody({
                  method: "POST",
                  path: "locale/changeLanguage",
                  contentType: amsResponse.contentTypes.json,
                  body: {
                    locale: locale
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function setLocale(_x) {
        return _setLocale.apply(this, arguments);
      }

      return setLocale;
    }(),
    getTranslations: function () {
      var _getTranslations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
        var locale, data, translations;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                locale = _ref3.locale;
                _context2.next = 3;
                return amsResponse.getData({
                  method: "GET",
                  path: (0, _url.urlPath)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["v1.2/translations/", "/", ""])), locale, translationNamespace)
                });

              case 3:
                data = _context2.sent;
                translations = data || [];
                return _context2.abrupt("return", translations.reduce(function (acc, _ref4) {
                  var code = _ref4.code,
                      translation = _ref4.translation;
                  return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, code, translation));
                }, {}));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getTranslations(_x2) {
        return _getTranslations.apply(this, arguments);
      }

      return getTranslations;
    }()
  };
};

exports.newApi = newApi;